import React from 'react';
import { useLocation } from 'react-router';
import AlertCircle from '../assets/icons/alert-circle.svg';
import { isUserAuthenticated } from '../utils';

const PageNotFound = () => {
    const user = JSON.parse(window.localStorage.getItem('user'));
    const { pathname } = useLocation();
    return (
        <div className='description-card flex justifyCenter alignCenter w-100'>
            <div className='card form-content' style={{ padding: 32 }}>
                <h1 className='title textCenter mt-24'>
                    {` جزاك اللهُ خيراً `}
                    <img
                        src={AlertCircle}
                        alt='warning-icon'
                        height={40}
                        width={40}
                        style={{ margin: '0 0.5em' }}
                    />
                </h1>
                <h6 className='redText textCenter mt-24'>آپ نے غلط صفحے کا انتخاب کیا ہے</h6>
                <h6 className='description mt-32 textCenter'>
                    <button
                        className='submit-button'
                        style={{ minWidth: 120, margin: '0 1rem' }}
                        onClick={() => isUserAuthenticated(user, pathname)}
                    >
                        <p>واپس جائیں</p>
                    </button>
                </h6>
            </div>
        </div>
    );
};
export default PageNotFound;
